import { css } from 'linaria';

export const form = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 496px;
  padding: 60px 48px 48px;
  margin: 24px 24px 24px 0;
  background-color: var(--background-primary);
  border-radius: var(--rounding-l);

  @media (--only-desktop) {
    width: 430px;
    padding: 52px 40px 40px;
  }

  @media (--only-tablet) {
    max-width: 532px;
    margin: 0 64px 40px;
  }

  @media (--only-mobile) {
    max-width: 100%;
    padding: 0;
    margin: 0;
  }
`;

export const formField = css`
  margin-bottom: 28px;
`;

export const sendButton = css`
  margin-top: 4px;
  margin-bottom: 24px;

  && {
    @media (--to-desktop) {
      padding: 10px 22px;
      font-size: 16px;
      line-height: 24px;
    }
  }
`;

export const linkStyle = css`
  display: inline-block;
  text-decoration: none;
  color: var(--text-secondary);

  &:hover {
    text-decoration: none;
    color: var(--text-secondary);
  }
`;

export const captionText = css`
  width: 342px;

  @media (--only-mobile) {
    width: auto;
  }

  && {
    a {
      display: inline;
    }
  }
`;
